import {IExternalLinksHandlersFactory} from "./external-links-handlers-factory.interface";
import {IRegistrationExternalLinkHandler} from "../handlers/registration/registration.external-link-handler.interface";
import {RegistrationExternalLinkHandler} from "../handlers/registration/registration.external-link-handler";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IMyAccountExternalLinkHandler} from "../handlers/my-account/my-account.external-link-handler.interface";
import {MyAccountExternalLinkHandler} from "../handlers/my-account/my-account.external-link-handler";
import {ICashierExternalLinkHandler} from "../handlers/cashier/cashier.external-link-handler.interface";
import {CashierExternalLinkHandler} from "../handlers/cashier/cashier.external-link-handler";
import {IOmgExternalLinkHandler} from "../handlers/omg/omg.external-link-handler.interface";
import {OmgExternalLinkHandler} from "../handlers/omg/omg.external-link-handler";
import {
    IForgotUserNameExternalLinkHandler
} from "../handlers/forgot-credentials/forgot-user-name/forgot-user-name.external-link-handler.interface";
import {
    ForgotUserNameExternalLinkHandler
} from "../handlers/forgot-credentials/forgot-user-name/forgot-user-name.external-link-handler";
import {
    IForgotPasswordExternalLinkHandler
} from "../handlers/forgot-credentials/forgot-password/forgot-password.external-link-handler.interface";
import {
    ForgotPasswordExternalLinkHandler
} from "../handlers/forgot-credentials/forgot-password/forgot-password.external-link-handler";
import {
    IPendingLoginExternalLinkHandler
} from "../handlers/pending-login/pending-login.external-link-handler.interface";
import {PendingLoginExternalLinkHandler} from "../handlers/pending-login/pending-login.external-link-handler";
import {
    IMyAccountUploadDocumentsExternalLinkHandler
} from "../handlers/my-account-upload-documents/my-account-upload-documents.external-link-handler.interface";
import {MyAccountUploadDocumentsExternalLinkHandler} from "../handlers/my-account-upload-documents/my-account-upload-documents.external-link-handler";
import {IGameLimitsExternalLinkHandler} from "../handlers/game-limits/game-limits.external-link-handler.interface";
import {GameLimitsExternalLinkHandler} from "../handlers/game-limits/game-limits.external-link-handler";
import {IContactUsExternalLinkHandler} from "../handlers/contact-us/contact-us.external-link-handler.interface";
import {ContactUsExternalLinkHandler} from "../handlers/contact-us/contact-us.external-link-handler";
import {IRichExternalLinkHandler} from "../handlers/rich/rich.external-link-handler.interface";
import {RichExternalLinkHandler} from "../handlers/rich/rich.external-link-handler";
import {IHelpExternalLinkHandler} from "../handlers/help/help.external-link-handler.interface";
import {HelpExternalLinkHandler} from "../handlers/help/help.external-link-handler";
import {
    IPendingActionExternalLinkHandler
} from "../handlers/pending-action/pending-action.external-link-handler.interface";
import {
    DepositPendingActionExternalLinkHandler
} from "../handlers/pending-action/deposit/deposit-pending-action.external-link-handler";
import {
    TransactionHistoryPendingActionExternalLinkHandler
} from "../handlers/pending-action/transaction-history/transaction-history-pending-action.external-link-handler";
import {
    RealGamePlayPendingActionExternalLinkHandler
} from "../handlers/pending-action/real-game-play/real-game-play-pending-action.external-link-handler";
import {
    IOpenRealGamePlayPendingActionOptions
} from "../handlers/pending-action/real-game-play/real-game-play-pending-action.external-link-handler.interface";


export class ExternalLinksHandlersFactory implements IExternalLinksHandlersFactory {
    constructor(protected readonly services: IServiceFactoryExtended) {

    }
    get registration(): IRegistrationExternalLinkHandler {
        return new RegistrationExternalLinkHandler(this.services);
    }

    get myAccount(): IMyAccountExternalLinkHandler {
        return new MyAccountExternalLinkHandler(this.services);
    }

    get cashier(): ICashierExternalLinkHandler {
        return new CashierExternalLinkHandler(this.services);
    }

    get omg(): IOmgExternalLinkHandler {
        return new OmgExternalLinkHandler(this.services);
    }

    get forgotUserName(): IForgotUserNameExternalLinkHandler {
        return new ForgotUserNameExternalLinkHandler(this.services);
    }

    get forgotPassword(): IForgotPasswordExternalLinkHandler {
        return new ForgotPasswordExternalLinkHandler(this.services);
    }

    get pendingLogin(): IPendingLoginExternalLinkHandler {
        return new PendingLoginExternalLinkHandler(this.services);
    }

    get realGamePlayPendingAction(): IPendingActionExternalLinkHandler<IOpenRealGamePlayPendingActionOptions> {
        return new RealGamePlayPendingActionExternalLinkHandler(this.services);
    }

    get depositPendingAction(): IPendingActionExternalLinkHandler<undefined> {
        return new DepositPendingActionExternalLinkHandler(this.services);
    }

    get transactionHistoryPendingAction(): IPendingActionExternalLinkHandler<undefined> {
        return new TransactionHistoryPendingActionExternalLinkHandler(this.services);
    }

    get myAccountUploadDocuments(): IMyAccountUploadDocumentsExternalLinkHandler {
        return new MyAccountUploadDocumentsExternalLinkHandler(this.services);
    }
    get gameLimits(): IGameLimitsExternalLinkHandler {
        return new GameLimitsExternalLinkHandler(this.services);
    }

    get contactUs(): IContactUsExternalLinkHandler {
        return new ContactUsExternalLinkHandler(this.services);
    }

    get rich(): IRichExternalLinkHandler {
        return new RichExternalLinkHandler(this.services);
    }

    get help(): IHelpExternalLinkHandler {
        return new HelpExternalLinkHandler(this.services);
    }
}